import "./Home.css";
import * as React from "react";
import { Navbar } from "../Navbar/Navbar";
import o1 from "../../images/o1.png";
import o2 from "../../images/o2.png";
import o3 from "../../images/o3.png";
import o4 from "../../images/o4.png";
import o5 from "../../images/o5.png";
import o6 from "../../images/o6.png";
import advise from "../../assets/Insurance Agent.png";
import customer from "../../assets/VNU_M625_04.png";
import claim from "../../assets/TV_M239_04.png";
import assitance from "../../assets/claimInsurance.png";
import family from "../../assets/top1 1.png";
import allinone from "../../assets/top2 1.png";
import img1 from "../../assets/bottom3 1.png";
import img2 from "../../assets/bottom1 1.png";
import img3 from "../../assets/bottom2 1.png";
import { Footer } from "./Footer";
import HomeBanner from "./HomeBanner";
// import { LazyLoadImage } from "react-lazy-load-image-component";
// import "react-lazy-load-image-component/src/effects/blur.css";

export const Home = () => {
  return (
    <>
      <Navbar />
      <HomeBanner />
      <section className="py-5">
        <div className="container py-5 text-center">
          <h3 className="mb-5">
            Why choose <span className="text-primary">VIBE</span>
          </h3>
          <div className="row">
            <div className="col-12 col-sm-6 col-md-3 text-center">
              {/* <LazyLoadImage
            delayTime={100}
            effect="blur"
            className="mb-4 img-fluid"
            src={advise}  
            //visibleByDefault={advise}
            /> */}
              <img
                className="mb-4 img-fluid"
                src={advise}
                alt=""
                loading="eager"
              />
              <h5 className="mb-5">
                Unbiased Advice <br /> From Experts Near You
              </h5>
            </div>
            <div className="col-12 col-sm-6 col-md-3 text-center">
              {/* <LazyLoadImage
           delayTime={100}
            effect="blur"
            className="mb-4 img-fluid"
            src={customer}  
            //visibleByDefault={customer}
            /> */}
              <img
                className="mb-4 img-fluid"
                src={customer}
                alt=""
                loading="eager"
              />

              <h5 className="mb-5">
                40 Lakh+ <br /> Customers
              </h5>
            </div>
            <div className="col-12 col-sm-6 col-md-3 text-center">
              {/* <LazyLoadImage
            delayTime={100}
            effect="blur"
            className="mb-4 img-fluid"
            src={claim}  
            //visibleByDefault={claim}
            /> */}
              <img
                className="mb-4 img-fluid"
                src={claim}
                alt=""
                loading="eager"
              />

              <h5 className="mb-5 ">
                Hassle-Free <br /> Claim Assistance
              </h5>
            </div>
            <div className="col-12 col-sm-6 col-md-3 text-center">
              {/* <LazyLoadImage
            delayTime={100}
            effect="blur"
            className="mb-4 img-fluid"
            src={assitance}  
            //visibleByDefault={assitance}
            /> */}
              <img
                className="mb-4 img-fluid"
                src={assitance}
                alt=""
                loading="eager"
              />
              <h5 className="mb-5">
                Easy Policy <br /> Renewal
              </h5>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5 bg-light">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-5 text-center">
              {/* <LazyLoadImage
                delayTime={100}
                delayMethod="throttle"
                effect="blur"
                className="mb-3 w-90 mx-auto img-fluid"
                src={family}
              /> */}
              <img
                loading="eager"
                className="mb-3 w-90 mx-auto img-fluid"
                src={family}
                alt="family"
              />
            </div>
            <div className="col-md-7 py-4">
              <h3 className="mb-5">
                Here’s why you’ll love{" "}
                <span className="text-primary">VIBE</span>
              </h3>
              <div className="p-3 mb-4 bg-white border rounded me-3">
                <h5 className="text-primary mb-2">
                  Make Your Claim Settlement Process Hassle Free
                </h5>
                <p className="mb-0">
                  Insuring things that matter to you shouldn’t come at a cost.
                  That’s why when you buy from us, you get insurance that fits
                  your pocket.
                </p>
              </div>
              <div className="p-3 mb-4 bg-white border rounded ms-3">
                <h5 className="text-primary mb-2">
                  Easiest Way of Selecting a Perfect Insurance Plan
                </h5>
                <p className="mb-0">
                  Insuring things that matter to you shouldn’t come at a cost.
                  That’s why when you buy from us, you get insurance that fits
                  your pocket.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5 bg-white">
        <div className="container py-5">
          <div className="row">
            <div className="col-md-5 text-center">
              {/* <LazyLoadImage
            delayTime={100}
            effect="blur"
            className="mb-3 img-fluid mx-auto"
            src={allinone}  /> */}
              <img
                className="mb-3 img-fluid mx-auto"
                src={allinone}
                alt=""
                loading="eager"
              />
            </div>
            <div className="col-md-7 py-4">
              <h3 className="mb-3">Manage All Policies In One Place</h3>
              <button className="btn btn-primary btn-lg mb-5">Download</button>
              <ul className="list-unstyled">
                <li className="mb-4">
                  <h4 className="mb-2">All policies, one app</h4>
                  <p className="mb-0">
                    Find and save all your policies, get reminders, track claims
                    on your fingertips
                  </p>
                </li>
                <li className="mb-4">
                  <h4 className="mb-2">Claim any policy</h4>
                  <p className="mb-0">
                    Get quick claims support from our experts for any policy,
                    any insurer
                  </p>
                </li>
                <li className="mb-4">
                  <h4 className="mb-2">All policies explained</h4>
                  <p className="mb-0">
                    Understand the features of your policies for complete risk
                    protection
                  </p>
                </li>
                <li className="mb-4">
                  <h4 className="mb-2">Consult an expert</h4>
                  <p className="mb-0">
                    Consult one of our 2.8 lakh+ advisors/POSPs on your
                    insurance
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5 bg-light">
        <div className="container pt-5 text-center">
          <h4 className="mb-5">
            Here’s why you’ll love <span className="text-primary">VIBE</span>
          </h4>
          <div className="row">
            <div className="col-md-4 text-center py-4">
              {/* <LazyLoadImage
            delayTime={100}
            delayMethod="throttle"
            effect="blur"
            className="mb-3 img-fluid"
            src={img2}  /> */}
              <img
                className="mb-3 img-fluid"
                src={img2}
                alt=""
                loading="eager"
              />
              <h5>Incredibly low premiums</h5>
              <p>
                Insuring things that matter to you shouldn’t come at a cost.
                That’s why when you buy from us, you get insurance that fits
                your pocket.
              </p>
            </div>
            <div className="col-md-4 text-center py-4">
              {/* <LazyLoadImage
            delayTime={100}
            delayMethod="throttle"
            effect="blur"
            className="mb-3 img-fluid"
            src={img3}  /> */}
              <img
                className="mb-3 img-fluid"
                src={img3}
                alt=""
                loading="eager"
              />
              <h5>Superquick and easy</h5>
              <p>
                We’re easy, effortless and 100% digital. Forget paperwork, just
                access all our services with just a few clicks.
              </p>
            </div>
            <div className="col-md-4 text-center py-4">
              {/* <LazyLoadImage
            delayTime={100}
            delayMethod="throttle"
            effect="blur"
            className="mb-3 img-fluid"
            src={img1}  /> */}
              <img
                className="mb-3 img-fluid"
                src={img1}
                alt=""
                loading="eager"
              />
              <h5>Hassle-free claims</h5>
              <p>
                We’re on a mission to make insurance claims stress-free. Just
                give us a call or file a claim online and experience cashless,
                speedy claim settlements.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5 bg-white">
        <div className="container text-center py-5">
          <h3 className="mb-2">Our Partners</h3>
          <p className="mb-5">Leading insurers for your financial freedom</p>
          <div className="d-flex w-100 align-items-center justify-content-around overflow-x-scroll row">
            <div className="col-lg-2 col-xl-2 col-md-3 col-sm-3">
              {/* <LazyLoadImage
            style={{width: "180px", height: "50px"}} 
            alt="one"
            className="partner-logo"
            src={o1}  /> */}
              <img
                src={o1}
                className="partner-logo"
                height="50px"
                style={{ width: "180px" }}
                alt="one"
                loading="eager"
              />
            </div>
            <div className="col-lg-2 col-xl-2 col-md-3 col-sm-3">
              {/* <LazyLoadImage
            style={{width: "200px", height: "50px"}}
            alt="one"
            className="partner-logo col-md-2"
            src={o2}  /> */}
              <img
                src={o2}
                className="partner-logo col-md-2 "
                height="50px"
                style={{ width: "200px" }}
                alt="one"
                loading="eager"
              />
            </div>
            <div className="col-lg-2 col-xl-2 col-md-3 col-sm-3">
              {/* <LazyLoadImage
            style={{width: "200px", height: "50px"}}
            alt="one"
            className="partner-logo col-md-2"
            src={o3}  /> */}
              <img
                src={o3}
                className="partner-logo col-md-2 "
                height="50px"
                style={{ width: "200px" }}
                alt="one"
                loading="eager"
              />
            </div>
            <div className="col-lg-2 col-xl-2 col-md-3 col-sm-3">
              {/* <LazyLoadImage
            style={{width: "200px", height: "50px"}}
            alt="one"
            className="partner-logo col-md-2"
            src={o4}  /> */}
              <img
                src={o4}
                className="partner-logo col-md-2 "
                height="50px"
                style={{ width: "200px" }}
                alt="one"
                loading="eager"
              />
            </div>
            <div className="col-lg-2 col-xl-2 col-md-3 col-sm-3">
              {/* <LazyLoadImage
            style={{width: "180px", height: "50px"}}
            alt="one"
            className="partner-logo col-md-2"
            src={o5}  /> */}
              <img
                src={o5}
                className="partner-logo col-md-2 "
                height="50px"
                style={{ width: "180px" }}
                alt="one"
                loading="eager"
              />
            </div>
            <div className="col-lg-2 col-xl-2 col-md-3 col-sm-3">
              {/* <LazyLoadImage
            style={{width: "180px", height: "50px"}}
            alt="one"
            className="partner-logo col-md-2"
            src={o6}  /> */}
              <img
                src={o6}
                className="partner-logo col-md-2 "
                height="50px"
                style={{ width: "180px" }}
                alt="one"
                loading="eager"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="py-4 bg-light">
        <div className="container py-4">
          <div className="row">
            <div className="col-md-6 text-left py-4">
              <h4>VIBE Insurance Broking and Advisory service Pvt Ltd</h4>
              <p>
                NO.33/54, Mount Poonamalee Road, Near Kathipara Flyover, St.
                Thomas Mount, Chennai - 600016
              </p>
            </div>
            <div className="col-md-6 text-center py-4 d-flex justify-content-center align-items-center">
              <div className="br-4">
                <h4>Download our vibe app soon!</h4>
                <a href="/" className="btn btn-primary mx-2">
                  Google Play
                </a>
                <a href="/" className="btn btn-dark mx-2">
                  App Store
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};
